import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Slider from "react-slick";
import { ethers } from "ethers";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import {
  HeadingTextcontainer,
  PriceButtonContainer,
  PriceText,
  PriceWrapper,
  Text,
  TextWrapper,
  ViewAllWrapper,
  ViewButton,
} from "../NftmarketGridStyledComponent";
import axios from "axios";
import CircularLoader from "../../../Components/CircularLoader/CircularLoader";
import environmentVariables from "../../../config/environmentVariables";

const Root = styled.div`
  margin: 20px 0;
`;
const Container = styled.div``;
const FeaturesWeaponContainer = styled.div`
  margin: 50px 0;
`;

const NftContainer = styled.div``;

const NftWrapper = styled.div`
  background: linear-gradient(
    160.61deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 101.7%
  );
  border-width: 1px 0px;

  /* border-style: solid; */
  border-color: #ffffff;
  backdrop-filter: blur(17.915px);
  border-radius: 30px;
  /* padding: 10px; */
  /* position: relative; */
  width: 100%;
  display: inline-block;
  position: relative;
`;

const Button = styled.button`
  border-radius: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  padding: 10px 20px;
  color: #000;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.5s;
  background: white;
  outline: none;
  &:hover {
    background: #1c3741;
    color: #208da5;
  }
  @media (max-width: 1260px) {
    font-size: 16px;
    padding: 8px 15px;
  }
  @media(max-width:540px){
  font-size:20px;
 padding: 20px 35px;
}
@media(max-width:420px){
  font-size:18px;
 padding: 10px 20px;
}
`;

const ImageWrapper = styled.div`
  /* display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 90%;
    cursor: pointer;
    border-radius: 20px;
    background-color: #262a2d;
    margin: 5%;
    -webkit-box-pack: center; */

  display: flex;
  -webkit-box-pack: center;
  width: 90%;
  cursor: pointer;
  border-radius: 20px;
  background-color: #262a2d;
  margin: 5%;
  overflow: hidden;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  padding: 15px 0;

  cursor: pointer;
  /* @media(max-width:1024px){
    padding: 30px 0;
  }
  @media (max-width: 1024px) {
    padding: 10px 0;
  }
  @media (max-width: 768px) {
    padding: 0;
  } */
`;
const Image = styled.img`
  width: 200px;
  height: 152px;
  aspect-ratio: auto 200 / 152;
  cursor: pointer;
  transition: 0.5s;
  &:hover {
    transform: scale(1.3);
  }
`;

const ContentContainer = styled.div`
  /* margin: 10px 0; */
  /* padding: 10px 0;
  background: linear-gradient(360deg, #000000 50%, rgba(0, 0, 0, 0.01) 100%);
  border-radius: 0 0px 10px 10px;

  margin-top:-50px; */
`;
const ContentWrapper = styled.div`
  margin: 15px 0;
  padding-left: 20px;
  padding-right: 20px;
  align-items: center;
  justify-content: space-between;
  display: flex;
  text-align: left;
`;
const ContentText = styled.text`
  font-size: 16px;
  font-weight: 600;
  /* margin: 4px 0; */
  font-style: normal;
  padding: 10px 0px;
  line-height: 22px;
  text-transform: capitalize;
  color: #ffffff;
  @media (max-width: 1440px) {
    font-size: 18px;
  }
`;

const CountContentText = styled.text`
  font-size: 14px;
  font-weight: 400;
  padding: 10px 0px;
  line-height: 22px;
  font-style: normal;
  color: #fb9829; 
  
`;


const ViewTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 0 20px;
`;
const ViewText = styled.text`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.5);
  ${(p) =>
    p.PriceText &&
    `
 display: flex;
    justify-content: end;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #8A8AA0;
    margin-bottom: 5px;
    text-align: start;
  `}
`;

const ViewTextWrapperContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const NftCategory = styled.div`
  font-size: 9px;
  font-weight: 800;
  color: #490d81;
  text-transform: uppercase;
  /* background-color: #d3b1f3; */
  background-color: ${(props) =>
    props.common ? "#dddddd" : props.uncommon ? "#a5e3b8" : "initial"};
  padding: 7px 12px;
  border-radius: 50px;
  position: absolute;
  bottom: 10px;
   /* right: -5px; */
  right: 5px;

  /* opacity: 0.7; */
  ${(p) =>
    p.uncommon == true ? "background-color: #22363e; color: #74bccb;" : ""}

  ${(p) =>
    p.common == true ? "background-color: #392e4a;color: #a98bc5;" : ""}
`;

const MeleeFeature = ({ data, allContractDetails }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [shootdata, setShootData] = useState();
  const [melledata, setMelleData] = useState();
  const [characterdata, setCharacterData] = useState();
  const [vehicledata, setVehicleData] = useState();
  const [isLoadingNFTs, setIsLoadingNFTs] = useState(false);
  const navigation = useNavigate();

  const ShootableHandle = () => {
    axios
      .post(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getfiltereddata/0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532?address=${allContractDetails?.address}`
      )
      // .then((response) => {
      //   console.log(response.data);
      //   setShootData(response.data);
      // })
      .then((response) => {
        // console.log("qqqqqqqqqqqqqqqq", response.data);
        if (Array.isArray(response.data)) {
          setShootData(response?.data);
          setIsLoadingNFTs(false);
        } else {
          console.error("API response is not an array:", response.data);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoadingNFTs(false);
      });
  };

  const MelleHandle = () => {
    axios
      .post(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getfiltereddata/0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532?address=${allContractDetails?.address}`
      )
      .then((response) => {
        // console.log("MelleHandleqqqqqqqqqqqq", response.data[0]);

        if (Array.isArray(response?.data)) {
          setMelleData(response?.data);
          // console.log("setMelleData", response.data);
        } else {
          console.error("API response is not an array:", response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const CharacterHandle = () => {
    axios
      .post(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getfiltereddata/0x7eb272ac9b9fec60c5a7921ccc075152a961111c?address=${allContractDetails?.address}`
      )

      .then((response) => {
        if (Array.isArray(response?.data)) {
          setCharacterData(response?.data);
        } else {
          console.error("API response is not an array:", response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const VehiclesHandle = () => {
    axios
      .post(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getfiltereddata/0x69cc97aad84e5aebd72ec147d7b81b72e22c3ece?address=${allContractDetails?.address}`
      )

      .then((response) => {
        if (Array.isArray(response?.data)) {
          setVehicleData(response?.data);
        } else {
          console.error("API response is not an array:", response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    setIsLoadingNFTs(true);
    ShootableHandle();
    MelleHandle();
    CharacterHandle();
    VehiclesHandle();
  }, [allContractDetails]);

  // console.log("111111............",Object.entries(data))
  // console.log("1111111111............",data)

  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    styled: {
      margin: "20px",
    },
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const checkIsUSDT = (address) => {
    if (address === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F") {
      return true;
    } else {
      return false;
    }
  };

  const convertedPrice = (currency, price) => {
    return checkIsUSDT(currency)
      ? Number(price) / 1000000
      : Number(price) / 1000000000000000000;
  };

  const getTradeCurrency = (id) => {
    let answer = "";

    if (id === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F") {
      answer = "USDT";
    }
    if (id === "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6") {
      answer = "MLD";
    }
    if (id === "0x0000000000000000000000000000000000001010") {
      answer = "MATIC";
    }

    return answer;
  };
  const getShootablesData = () => {
    if (isLoadingNFTs == true) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularLoader></CircularLoader>
        </div>
      );
    } else if (shootdata?.length == 0) {
      return <div>No Data</div>;
    } else {
      return (
        <>
          <Slider key={shootdata?.length} initialSlide={0} {...settings}>
            {shootdata?.map((item, index) => {
              return (
                <>
                  <NftWrapper key={index}>
                    <ImageWrapper
                      onClick={() => {
                        // const data = arrivalList[index];

                        if (item?.isFixed === true) {
                          navigation(
                            `/nftdetails/0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532/${parseInt(
                              item?.tokenId
                            )}`
                          );
                        } else {
                          navigation(
                            `/specificnft/0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532/${parseInt(
                              item?.tokenId
                            )}`
                          );
                        }
                      }}
                    >
                      <NftCategory
                        common={item?.category === "common"}
                        uncommon={item?.category === "uncommon"}
                      >
                        {item?.category=="uncommon"?"rare":item?.category}
                      </NftCategory>
                      <Image
                        src={`${environmentVariables?.cdnUrl}${
                          item?.skinId 
                        }.png`}
                      />
                    </ImageWrapper>
                    <ContentContainer>
                      <ContentWrapper>
                        <ContentText>{item.name}</ContentText>
                        <CountContentText>{`${item?.count} Left`}</CountContentText>
                        {/* <ContentText>#{item.tokenId}</ContentText> */}
                      </ContentWrapper>
                      <PriceButtonContainer>
                        <PriceWrapper>
                          <PriceText Heading> Best Price </PriceText>
                          <PriceText PriceTextValue>
                            {item?.price || 0} {item?.currency=="MLD"||item?.currency=="LORD"?"$":""}{item?.currency}
                            {/* {(convertedPrice(
                              nft.tradeCurrency,
                              parseInt(nft.price)
                            ))}{" "}
                            {getTradeCurrency(nft.tradeCurrency)}{" "} */}
                          </PriceText>
                        </PriceWrapper>
                        <PriceWrapper
                          hashValue
                          onClick={() => {
                            // const data = arrivalList[index];

                            if (item?.isFixed === true) {
                              navigation(
                                `/nftdetails/0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532/${parseInt(
                                  item?.tokenId
                                )}`
                              );
                            } else {
                              navigation(
                                `/specificnft/0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532/${parseInt(
                                  item?.tokenId
                                )}`
                              );
                            }
                          }}
                        >
                          <Button>
                            {" "}
                            {item?.isFixed === true ? "Place a Bid" : "Buy Now"}
                          </Button>
                        </PriceWrapper>
                      </PriceButtonContainer>
                    </ContentContainer>
                  </NftWrapper>
                </>
              );
            })}
          </Slider>
        </>
      );
    }
  };
  return (
    <Root>
      <Container>
        <>
          <FeaturesWeaponContainer>
            <HeadingTextcontainer>
              <TextWrapper>
                <Text> Featured Melee </Text>
              </TextWrapper>
              <ViewAllWrapper
                onClick={() =>
                  // navigation(`/nftcategories/${value.contract.toLowerCase()}`)
                  navigation(
                    "/nftcategories/0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532"
                  )
                }
              >
                <ViewButton>View All</ViewButton>
              </ViewAllWrapper>
            </HeadingTextcontainer>

            <NftContainer>{getShootablesData()}</NftContainer>
          </FeaturesWeaponContainer>
        </>
      </Container>
    </Root>
  );
};

export default MeleeFeature;
